function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 0-128 256 128 256c141.385 0 256-114.615 256-256s-114.615-256-256-256z",
    fill: "#4640b1",
    "data-original": "#28abfa",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 256c0 141.385 114.615 256 256 256v-512c-141.385 0-256 114.615-256 256z",
    fill: "#6159f8",
    "data-original": "#14cfff",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 60-98 196 98 196c108.248 0 196-87.752 196-196s-87.752-196-196-196z",
    fill: "#a8a4ed",
    "data-original": "#c4f3ff",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60 256c0 108.248 87.752 196 196 196v-392c-108.248 0-196 87.752-196 196z",
    fill: "#ffffff",
    "data-original": "#ffffff",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.426 277.213-42.426-42.426h-20l20 42.426 21.213 21.213z",
    fill: "#574fdc",
    "data-original": "#340d66",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.794 149.581-21.213 21.213 106.419 106.419v-42.426z",
    fill: "#574fdc",
    "data-original": "#373e9f",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m341.561 149.227-85.561 85.56-20 42.426h20l106.773-106.774z",
    fill: "#574fdc",
    "data-original": "#373e9f",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.574 277.213 21.213 21.213 21.213-21.213v-42.426z",
    fill: "#3857bc",
    "data-original": "#3857bc",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271 90h-15l-10 15 10 15h15z",
    fill: "#574fdc",
    "data-original": "#340d66",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241 90h15v30h-15z",
    fill: "#574fdc",
    "data-original": "#373e9f",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271 392h-15l-10 15 10 15h15z",
    fill: "#574fdc",
    "data-original": "#340d66",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241 392h15v30h-15z",
    fill: "#574fdc",
    "data-original": "#373e9f",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90 241h30v30h-30z",
    fill: "#574fdc",
    transform: "matrix(0 -1 1 0 -151 361)",
    "data-original": "#373e9f",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392 241h30v30h-30z",
    fill: "#574fdc",
    transform: "matrix(0 -1 1 0 151 663)",
    "data-original": "#340d66",
    style: {},
    className: ""
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.9d8d10e0.svg";
export { ForwardRef as ReactComponent };